import constants from '../constants'

const postMessageDomain = () => {
  const link = document.createElement('a')
  link.href = constants.POST_MESSAGE_ADDRESS
  return link.hostname
}

export const sendPostMessage = (message) => {
  if (constants.LIST_ALLOW_DOMAINS.some((element) => element.indexOf(postMessageDomain()) !== -1)) {
    window.parent.postMessage(message, constants.POST_MESSAGE_ADDRESS)
  }
}

export default sendPostMessage



// WEBPACK FOOTER //
// ./src/services/post-communication.js